import { motion } from "framer-motion";
import { FORMATS } from "../config";

export const Formats = () => {
  return (
    <section id="formats" data-testid="formats-section" className="relative py-24 md:py-40 max-w-[1600px] mx-auto px-6 md:px-12">
      <div className="mb-14 md:mb-20 max-w-3xl">
        <p className="font-grotesk uppercase tracking-[0.35em] text-xs text-[#d8ab4e] mb-6">Choose Your Edition</p>
        <h2 className="font-display text-4xl sm:text-6xl leading-[0.95]">
          Own it in <span className="gold-text italic">every</span> format.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {FORMATS.map((f, i) => (
          <motion.div
            key={f.name}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`format-${f.name.toLowerCase()}`}
            className={`relative flex flex-col justify-between border p-8 md:p-10 min-h-[320px] transition-colors ${
              f.tag ? "border-[#d8ab4e] bg-[#12100a]" : "border-[#d8ab4e]/25 bg-transparent"
            }`}
          >
            {f.tag && (
              <span className="absolute top-0 right-0 bg-[#d8ab4e] text-[#0a0805] text-[10px] font-semibold uppercase tracking-[0.2em] px-4 py-2">
                {f.tag}
              </span>
            )}
            <div>
              <h3 className="font-display text-3xl text-[#f3ead6] mb-3">{f.name}</h3>
              <p className="font-body text-[#9a8f78] text-sm">{f.note}</p>
              {f.isbn && <p className="mt-2 font-body text-[#7d7460] text-xs tracking-wide">ISBN {f.isbn}</p>}
            </div>
            <div>
              <p className="font-grotesk font-black text-5xl md:text-6xl gold-text mb-6 tracking-tighter">{f.price}</p>
              {f.href ? (
                <a
                  href={f.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`format-buy-${f.name.toLowerCase()}`}
                  className="group inline-flex items-center gap-2 w-full justify-center bg-[#d8ab4e] text-[#0a0805] px-6 py-4 font-semibold uppercase tracking-widest text-sm hover:bg-[#f2c968] transition-colors"
                >
                  Buy Now
                  <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
                </a>
              ) : (
                <a
                  href="#formats"
                  data-testid={`format-notify-${f.name.toLowerCase()}`}
                  className="inline-flex items-center gap-2 w-full justify-center border border-[#d8ab4e]/40 text-[#e7dcc2] px-6 py-4 font-semibold uppercase tracking-widest text-sm cursor-default"
                >
                  Coming Soon
                </a>
              )}
            </div>
          </motion.div>
        ))}
      </div>
      <p className="mt-8 text-xs uppercase tracking-[0.25em] text-[#7d7460]">Now available in eBook &amp; Paperback</p>
    </section>
  );
};

export default Formats;
